import { render, staticRenderFns } from "./AgreementPage.vue?vue&type=template&id=5786e6da&scoped=true"
import script from "./AgreementPage.vue?vue&type=script&lang=js"
export * from "./AgreementPage.vue?vue&type=script&lang=js"
import style0 from "./AgreementPage.vue?vue&type=style&index=0&id=5786e6da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5786e6da",
  null
  
)

export default component.exports